/**
 * Transfer Subscription Accendo Action Creators
 */
import { Kushki } from "@kushki/js";
import { ErrorResponse } from "@kushki/js/lib/types/error_response";
import { TransferSubscriptionTokenRequest } from "@kushki/js/lib/types/transfer_subscription_token_request";
import { setErrorMessage } from "components/Error/store/Actions";
import {
  hideOverlay,
  showOverlay,
} from "components/OverLay/store/ActionCreators";
import { Actions } from "containers/TransferSubscriptionAccendo/store/Actions";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { TokenResponse } from "types/remote/token_response";
import { ITransferSubscriptionAccendoActionCreator } from "types/transfer_subscription_accendo_action_creator";
import { ITransferSubscriptionAccendoFormProps } from "types/transfer_subscription_accendo_form_props";
import { ITransferSubscriptionActionCreator } from "types/transfer_subscription_action_creator";

function getStatusValidity(
  state: ITransferSubscriptionAccendoFormProps
): boolean {
  let isValid: boolean = true;
  const inputs: string[] = ["documentEmailInput"];

  for (const inputName of inputs) isValid = state[inputName].valid && isValid;

  return isValid;
}

const inputAction: (
  payload: IInputProps
) => ITransferSubscriptionAccendoActionCreator = (
  payload: IInputProps
): ITransferSubscriptionAccendoActionCreator => ({
  type: Actions.UPDATE_TRANSFER_INPUT,
  input: payload,
});

const setDirty: (
  payload: IInputProps
) => ITransferSubscriptionAccendoActionCreator = (
  payload: IInputProps
): ITransferSubscriptionAccendoActionCreator => ({
  type: Actions.SET_TRANSFER_INPUT_DIRTY,
  input: payload,
});

const changeStatus: () => ITransferSubscriptionAccendoActionCreator = (): ITransferSubscriptionAccendoActionCreator => ({
  type: Actions.SWITCH_TRANSFER_VALIDITY,
});

const tokenAction: (
  payload: string
) => ITransferSubscriptionAccendoActionCreator = (
  payload: string
): ITransferSubscriptionAccendoActionCreator => ({
  type: Actions.SET_TRANSFER_SUBSCRIPTION_ACCENDO_TOKEN,
  token: payload,
});

function updateInput(
  payload: IInputProps
): ThunkAction<
  void,
  CajitaStore,
  undefined,
  ITransferSubscriptionAccendoActionCreator
> {
  return (
    dispatch: ThunkDispatch<
      CajitaStore,
      undefined,
      ITransferSubscriptionAccendoActionCreator
    >,
    getState: () => CajitaStore
  ): void => {
    dispatch(inputAction(payload));
    const state: ITransferSubscriptionAccendoFormProps = getState()
      .transferSubscriptionAccendo;
    const status: boolean = getStatusValidity(state);

    if (state.isValid !== status) dispatch(changeStatus());
  };
}

function getTransferSubscriptionAccendoToken(
  body: TransferSubscriptionTokenRequest
): ThunkAction<
  void,
  CajitaStore,
  undefined,
  ITransferSubscriptionActionCreator
> {
  return (dispatch: Function, getState: () => CajitaStore): void => {
    const kushki: Kushki = getState().config.kushkiJS as Kushki;

    dispatch(showOverlay());
    kushki.requestTransferSubscriptionToken(
      body,
      (response: TokenResponse | ErrorResponse) => {
        if ("token" in response) dispatch(tokenAction(response.token));
        else {
          dispatch(setErrorMessage(response.message));
          dispatch(hideOverlay());
        }
      }
    );
  };
}

export {
  setDirty,
  updateInput,
  getTransferSubscriptionAccendoToken,
  changeStatus,
};



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptionAccendo/store/ActionCreators.tsx